import { render, staticRenderFns } from "./mo-datepicker.html?vue&type=template&id=61200265&external"
import script from "./mo-datepicker.ts?vue&type=script&lang=ts&external"
export * from "./mo-datepicker.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61200265')) {
      api.createRecord('61200265', component.options)
    } else {
      api.reload('61200265', component.options)
    }
    module.hot.accept("./mo-datepicker.html?vue&type=template&id=61200265&external", function () {
      api.rerender('61200265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-datepicker/mo-datepicker.vue"
export default component.exports